import Vue from 'vue'
import VueRouter from 'vue-router'
import GateWayView from "@/views/GateWayView.vue";
import PaymentView from "@/views/PaymentView.vue";
import FarmDepotPaymentView from "@/views/FarmDepotPaymentView.vue";
import ProjectDocumentationView from "@/views/ProjectDocumentationView.vue";

Vue.use(VueRouter)

const routes = [
    {
        path: '/payment/:company',
        name: "paymentView",
        component: PaymentView,
    },
    {
        path: '/payment/farmdepot',
        name: "farmDepotPayment",
        component: FarmDepotPaymentView,
    },
    {
        path: '/project-documentation',
        name: "projectDocumentation",
        component: ProjectDocumentationView,
    },
    {
        path: '/',
        name: "GateWayView",
        component: GateWayView,
    },
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

export default router
